import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";

import styles from "./BioModal.module.scss";
import { messages } from "../Introduction.messages";
import { useUi } from "@jelly/lesson";
import { PhotoView } from "../../../../photo-view/PhotoView";

import * as appConfig from "appConfig";

type NielsBioModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;
export const NielsBioModal: React.FC<NielsBioModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props} title={formatMessage(messages.bioNielsTitle)}>
      <div className={styles.slide}>
        <div className={styles.content}>
          <div className={styles.description}>{formatMessage(messages.bioNielsDescription)}</div>
          <div className={styles.image}>
            <PhotoView
              key={"logical"}
              imgSrc={`${appConfig.STATIC_ASSETS_URL}/lms/case/case06/introduction/1.jpg`}
              imgMode={"contain"}
            />
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

//TODO: override scrollbars colors
